import { render, staticRenderFns } from "./userinfo.vue?vue&type=template&id=1b431190&scoped=true&"
import script from "./userinfo.vue?vue&type=script&lang=ts&"
export * from "./userinfo.vue?vue&type=script&lang=ts&"
import style0 from "./userinfo.vue?vue&type=style&index=0&id=1b431190&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b431190",
  null
  
)

export default component.exports